import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "top-nav" }
const _hoisted_2 = { class: "top-nav-box flex-between" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "right" }
const _hoisted_6 = {
  key: 0,
  class: "flex-center"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "dropdown-menu avatar-dropdown"
}
const _hoisted_9 = { class: "dropdown-item flex-between" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 0,
  class: "dropdown-menu language-dropdown"
}
const _hoisted_14 = ["onClick"]

import { showLogin } from '@/views/components/Login';
import { ref, onMounted, onUnmounted, computed, watch } from 'vue';
import { originObj } from '@/config/index';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import {useUserStore} from '@/store/modules/userStore'
import { storeToRefs } from 'pinia';



export default /*@__PURE__*/_defineComponent({
  __name: 'TopNav',
  setup(__props) {

const userStore = useUserStore()
const { tokenAction, userInfoAction } = userStore
const { token, userInfo } = storeToRefs(userStore)


const router = useRouter()
const route = useRoute()
const { t, locale } = useI18n();

const showAvatarDropdown = ref<boolean>(false);
const showLanguageDropdown = ref<boolean>(false);






const loginFn = () => {
    showLogin()
}

// 切换头像下拉菜单
const toggleAvatarDropdown = () => {
    showAvatarDropdown.value = !showAvatarDropdown.value;
    showLanguageDropdown.value = false; // 关闭语言下拉菜单
}

const handleLogout = () => {
    tokenAction.clear()
    userInfoAction.clear()
    window.location.reload()
    // isLogin.value = false;
    // showAvatarDropdown.value = false;
}





// 切换语言下拉菜单
// lang 为下拉显示的简短 code，map 到 i18n 的完整 locale
const langList = ref([
    { lang: 'en', name: 'English' },
    { lang: 'zh', name: '简体中文' },
    { lang: 'zh-tw', name: '繁体中文' },
    { lang: 'id', name: 'Indonesian' },
    { lang: 'ja', name: '日本語' },
    { lang: 'ko', name: '한국어' },
    { lang: 'th', name: 'ภาษาไทย' }
])

// 当前下拉里选中的短 code（用于高亮）。使用 computed 确保响应式更新
const defaultLang = computed(() => locale.value)

const toggleLanguageDropdown = () => {
    showLanguageDropdown.value = !showLanguageDropdown.value;
    showAvatarDropdown.value = false; // 关闭头像下拉菜单
}

// 语言切换功能：将短 code 映射到 i18n 的 locale，设置并持久化
const changeLanguage = (shortLang: string) => {
    locale.value = shortLang
    localStorage.setItem('locale', shortLang)
    showLanguageDropdown.value = false
}






// 点击页面其他地方关闭下拉菜单
const handleClickOutside = (event: Event) => {
    const target = event.target as HTMLElement;
    if (!target.closest('.nav-icon-wrapper')) {
        showAvatarDropdown.value = false;
        showLanguageDropdown.value = false;
    }
}

// 监听语言变化，确保组件响应式更新
watch(() => locale.value, (newLang) => {
    // 语言切换时，可以在这里执行额外的操作
})

// 添加和移除点击事件监听器
onMounted(() => {
    document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(originObj)?.logo?.top || '',
          alt: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_unref(route).fullPath !== '/index')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (!_unref(token))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "login-btn btn-color",
                    onClick: loginFn
                  }, _toDisplayString(_unref(t)('buttons.login')), 1))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "nav-icon-wrapper",
                    onClick: toggleAvatarDropdown
                  }, [
                    _createElementVNode("img", {
                      class: "nav-icon",
                      src: require('@/assets/img/nav/avatar.png'),
                      alt: ""
                    }, null, 8, _hoisted_7),
                    (showAvatarDropdown.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("img", {
                              class: "avatar",
                              src: require('@/assets/img/nav/avatar2.png'),
                              alt: ""
                            }, null, 8, _hoisted_10),
                            _createElementVNode("span", null, _toDisplayString(_unref(userInfo).vname), 1)
                          ]),
                          _createElementVNode("div", {
                            class: "dropdown-item choose-item",
                            style: {justifyContent:'flex-start'},
                            onClick: handleLogout
                          }, [
                            _createElementVNode("img", {
                              class: "nav-icon",
                              src: require('@/assets/img/nav/logout.png'),
                              alt: ""
                            }, null, 8, _hoisted_11),
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('buttons.logout')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "nav-icon-wrapper",
          onClick: toggleLanguageDropdown
        }, [
          _createElementVNode("img", {
            class: "nav-icon",
            src: require('@/assets/img/nav/language.png'),
            alt: ""
          }, null, 8, _hoisted_12),
          (showLanguageDropdown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langList.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.name,
                    class: _normalizeClass(["dropdown-item", [item.lang == defaultLang.value && 'choose-item']]),
                    onClick: ($event: any) => (changeLanguage(item.lang))
                  }, _toDisplayString(item.name), 11, _hoisted_14))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})